import { createFileRoute } from '@tanstack/react-router';
import { EditPayoutForm } from '@/features/cleaner/edit-payout-form';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/payout-edit'
)({
  component: EditPayoutForm,
});
